import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=ea3078fc&scoped=true&"
import script from "./Caption.vue?vue&type=script&lang=js&"
export * from "./Caption.vue?vue&type=script&lang=js&"
import style0 from "./Caption.vue?vue&type=style&index=0&id=ea3078fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3078fc",
  null
  
)

export default component.exports